import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { LeftOutlined, ReloadOutlined, DownOutlined } from '@ant-design/icons';


// ANT DESIGN IMPORTS
import {
    Modal,
    Input,
    Row,
    Typography,
    DatePicker,
    Col,
    Card,
    Table,
    Form,
    Spin,
    Select,
    Button,
    Statistic,
    Divider,

} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import appStatic from "../../../../../../config/appStatic";
import definedApi from "../../../../../../services/definedApi";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { rightAction } from "../../../../../../redux/actions";
import CustomButton from "../../../../../../components/custom/CustomButton";
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";
import DownloadTableButtons from "../../../../../../components/DownloadTableButtons";

const Search = Input;

const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => { },
    getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
    }),
};

const filterOptions = [
    {
        value: "All",
        label: "All"
    },
    {
        value: "Manual Entries",
        label: "Manual Entries"
    },
    {
        value: "System Entries",
        label: "System Entries"
    }
]

const columns = [
    {
        title: "Entry ID",
        dataIndex: "id",
    },
    {
        title: "Office",
        dataIndex: "office",
        sorter: (a, b) => a.branch.localeCompare(b.branch),
    },
    {
        title: "Transaction Date",
        dataIndex: "transactionDate",
        sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
    },
    {
        title: "Transaction ID",
        dataIndex: "transactionId",
    },
    {
        title: "Type",
        dataIndex: "type",
        sorter: (a, b) => a.account.localeCompare(b.account),
    },
    {
        title: "Created By",
        dataIndex: "createdBy",
    },
    {
        title: "Account",
        dataIndex: "account",
    },
    {
        title: "Debit",
        dataIndex: "debit",
    },
    {
        title: "Credit",
        dataIndex: "credit",
    }
];

const SearchJournalEntries = (props) => {
    const { userData, rightBtn, rightAction } = props;
    const { RangePicker } = DatePicker;
    const { monthList } = appStatic;
    const { session } = userData;
    const { Text } = Typography;
    const navigate = useNavigate();
    const { state } = useLocation();

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [selectedRow, setSelectedRow] = useState(null);
    const [tableCount, setTableCount] = useState("10");
    const [journalEntryList, setJournalEntryList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [accountData, setAccountData] = useState([]);
    const [officeData, setOfficeData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    function selectTableCount(value) {
        setTableCount(value);
    }

    useEffect(() => {
        getOffice();
        getGlAccount();
        getJournalEntriesListAction();

        // //DISABLE ALL RIGHTSIDEBAR ACTION
        dispatch({
            type: cnt.CLEAR_RIGHT_BTN,
        });
        // rightAction(cnt.RIGHT_ADD_BTN);
        setIsLoading(false);
    }, []);


    const getJournalEntriesListAction = () => {

        const params = {
            dateFormat: "dd MMMM yyyy",
            offset: 0,
            limit: 14,
            locale: "en",
            loanId: state.id
        }

        const url = `${apiConfig.Journalentries}?`
        let body = {
            session,
            params
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                const objList = res.pageItems;

                let tempArray = [];

                objList.forEach((element) => {
                    tempArray.push({
                        key: element?.id,
                        id: element?.id ? element?.id : "-",
                        office: element?.officeName ? element?.officeName : "-",
                        branchId: element?.officeId ? element?.officeId : "-",
                        transactionDate: element?.transactionDate
                            ? `${element?.transactionDate[2]} ${monthList[element?.transactionDate[1] - 1]
                            } ${element?.transactionDate[0]}`
                            : "-",
                        transactionId: element?.transactionId
                            ? element?.transactionId
                            : "-",
                        type: element?.glAccountType?.value
                            ? element?.glAccountType?.value
                            : "-",
                        createdBy: element?.createdByUserName
                            ? element?.createdByUserName
                            : "-",
                        account: element?.glAccountName
                            ? `${element?.glAccountName} (${element?.glAccountCode})`
                            : "-",
                        debit:
                            element?.entryType?.value?.toLowerCase() === "debit"
                                ? element?.amount
                                : "-",
                        credit:
                            element?.entryType?.value?.toLowerCase() === "credit"
                                ? element?.amount
                                : "-",
                        transactionTag: element?.entryType?.value
                            ? element?.entryType?.value === "DEBIT"
                                ? "Dr"
                                : element?.entryType?.value === "CREDIT"
                                    ? "Cr"
                                    : "-"
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            "-"
                        ),
                        amountToUse: element?.amount ? element?.amount : 0,
                    });
                });

                setJournalEntryList(tempArray);
                setIsLoading(false);
            }
        });
    };

    function getOffice() {
        let body = {
            session,
        };

        BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
            } else {
                const objList = res;
                let temp = [];

                objList.forEach((element) => {
                    temp.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                setOfficeData(temp);
            }
        });
    }

    function getGlAccount() {
        let body = {
            session,
        };

        BOM.FetchReqAction(body, definedApi.GetSpecificGLList, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
            } else {
                const objList = res;
                let temp = [];

                objList.forEach((element) => {
                    temp.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                setAccountData(temp);
            }
        });
    }


    // FLOAT METHODS
    function handleOnView() {
        // console.log(selectedRow);return
        delete selectedRow.amount;
        selectedRow.amount = selectedRow.amountToUse;
        const { detailBtn } = rightBtn;
        if (detailBtn.toLowerCase() === "primary") {
            navigate("/detail-journal-entry", { state: { ...state, transactionId: selectedRow.transactionId } });
        } else {
            console.log("Please choose a record from the table to open");
        }
    }

    const onSelectItemAction = (selectedRowKeys, objParam) => {
        //HOLD THE OBJECT SELECTED HERE
        setSelectedRow(objParam[0]);
        [cnt.RIGHT_DETAIL_BTN].map((item) => {
            dispatch({
                type: item,
            });
        });
    };


    function backOnClick() {
        navigate("/detail-loan-account", { state: state });
    }

    return (
        <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
            <TopContent
                pageTitle={labelConfig.journalEntries}
                pageItems={staticConfig.journalEntriesBreadcrumbItems}
            />
            <Card
                headStyle={{ borderBottomWidth: 0 }}
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}

                title={
                    <Row
                        style={{
                            alignContent: "center",
                            width: "8%",
                        }}
                    >
                        <Button
                            icon={<LeftOutlined />}
                            type="text"
                            style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                            }}
                            onClick={backOnClick}
                        >
                            <Text
                                style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                            >
                                Back
                            </Text>
                        </Button>
                    </Row>
                }
            >

                <Spin spinning={isLoading} size="large">
                    <Form
                        // onFinish={onSubmit}
                        layout="vertical"
                        style={{ paddingTop: 20, marginBottom: 50 }}
                    >

                        <Row>
                            <SearchParametersModal
                                officeData={officeData}
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                                accountData={accountData}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                setShowSearch={setShowSearch}
                                setJournalEntryList={setJournalEntryList}
                                setOriginalList={setOriginalList}
                                session={session}
                                monthList={monthList}
                                getJournalEntriesListAction={getJournalEntriesListAction}
                            />

                            <DownloadTableButtons
                                downloadData={journalEntryList}
                                columns={columns}
                                fileName={"Journal Entry List"}
                            />
                        </Row>

                        <Table
                            rowSelection={{
                                type: "radio",
                                ...rowSelection,
                                onChange: onSelectItemAction,
                            }}
                            columns={columns}
                            dataSource={journalEntryList}
                            bordered
                            pagination={{
                                position: "bottomCentre",
                                pageSize: tableCount,
                            }}
                        />
                    </Form>
                </Spin>
            </Card>
        </MainLayout>
    );
};


const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(SearchJournalEntries);


const SearchParametersModal = (props) => {

    const { officeData, accountData, isModalOpen, setIsModalOpen, setIsLoading, setShowSearch, setJournalEntryList, setOriginalList, isLoading, session, monthList, getJournalEntriesListAction } = props;
    const { RangePicker } = DatePicker;

    const [useForm] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onRefresh = () => {
        useForm.resetFields();
        getJournalEntriesListAction();
    };

    const onSubmit = (formValues) => {

        formValues.fromDate = BOM.DateTime(
            formValues.date[0],
            "only-date"
        );

        formValues.toDate = BOM.DateTime(
            formValues.date[1],
            "only-date"
        );

        const params = {
            dateFormat: "dd+MMMM+yyyy",
            glAccountId: formValues.glAccountId,
            officeId: formValues.officeId,
            offset: 0,
            limit: 14,
            locale: "en",
            fromDate: encodeURIComponent(formValues.fromDate).replace(/%20/g, "+"),
            toDate: encodeURIComponent(formValues.toDate).replace(/%20/g, "+"),
            manualEntriesOnly: ""
        }

        const url = `${apiConfig.Journalentries}?`

        const body = {
            ...formValues,
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            // method: "POST",
            session,
            params
        };

        setIsLoading(true);
        setShowSearch(true);
        BOM.FetchReqAction(
            body, url, (err, res) => {
                if (err) {
                    BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
                } else {
                    const objList = res.pageItems;
                    let tempArray = [];

                    objList.forEach((element) => {
                        tempArray.push({
                            key: element?.id,
                            id: element?.id ? element?.id : "-",
                            office: element?.officeName ? element?.officeName : "-",
                            branchId: element?.officeId ? element?.officeId : "-",
                            transactionDate: element?.transactionDate
                                ? `${element?.transactionDate[2]} ${monthList[element?.transactionDate[1] - 1]
                                } ${element?.transactionDate[0]}`
                                : "-",
                            transactionId: element?.transactionId
                                ? element?.transactionId
                                : "-",
                            type: element?.glAccountType?.value
                                ? element?.glAccountType?.value
                                : "-",
                            createdBy: element?.createdByUserName
                                ? element?.createdByUserName
                                : "-",
                            account: element?.glAccountName
                                ? `${element?.glAccountName} (${element?.glAccountCode})`
                                : "-",
                            debit:
                                element?.entryType?.value?.toLowerCase() === "debit"
                                    ? element?.amount
                                    : "-",
                            credit:
                                element?.entryType?.value?.toLowerCase() === "credit"
                                    ? element?.amount
                                    : "-",
                            transactionTag: element?.entryType?.value
                                ? element?.entryType?.value === "DEBIT"
                                    ? "Dr"
                                    : element?.entryType?.value === "CREDIT"
                                        ? "Cr"
                                        : "-"
                                : "-",
                            amount: element?.amount ? (
                                <Statistic
                                    value={element?.amount}
                                    precision={2}
                                    valueStyle={{ fontSize: "16px" }}
                                />
                            ) : (
                                "-"
                            ),
                            amountToUse: element?.amount ? element?.amount : 0,
                        });
                    });

                    //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.

                    setJournalEntryList(tempArray);

                    //keep the orginal data to use after gList is modified when change from autorise to disable
                    setOriginalList(tempArray);

                    //STOP LOAD
                    setIsLoading(false);
                    useForm.resetFields()
                }
            }
        );
    };

    return (
        <Row>

            <Button
                type="primary"
                className="of-primaryBtnColor"
                onClick={showModal}
                shape="round"
            >
                <DownOutlined />
                {labelConfig.parameters}
            </Button>

            <Button
                type="primary"
                shape="round"
                className="of-primaryBtnColor"
                onClick={onRefresh}
                icon={<ReloadOutlined />}
                loading={isLoading}
                style={{
                    marginLeft: 10,
                    marginBottom: "auto",
                }}
            >
                {labelConfig.refresh}
            </Button>

            <Divider style={{ marginTop: 10, marginBottom: 30 }} />

            <Modal
                title="Search Parameters"
                open={isModalOpen}
                footer={null}
                width={1000}
                onCancel={handleCancel}
            >

                <Form
                    form={useForm}
                    layout="vertical"
                    onFinish={onSubmit}
                    name="address-info"
                >

                    <Row >
                        <Divider />

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.branch}
                                name={"officeId"}
                            >
                                <Select
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.branch,
                                        "select"
                                    )}
                                    options={officeData}
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    showSearch
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.account}
                                name={"accountId"}
                            >
                                <Select
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.account,
                                        "select"
                                    )}
                                    options={accountData}
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    showSearch
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.filter}
                                name={"filter"}
                            >
                                <Select
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.filter,
                                        "select"
                                    )}
                                    options={filterOptions}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.dateRange}
                                name="date"

                            >
                                <RangePicker
                                    style={{
                                        width: '100%',
                                        height: 35
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>

                            <Form.Item
                                label={labelConfig.transactionId}
                                name="transactionId"
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.transactionId)}

                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider />
                    <Form.Item>
                        <Row>
                            <CustomButton
                                content="Search"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#92428B"
                                colorText="white"
                                hoverBackground="#AD4EA7"
                                onClick={handleCancel}
                            />
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
        </Row>
    );
};